(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tell-us-your-story"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.currentScript ? document.currentScript.closest('.cq-story') : document.querySelector('.cq-story');
  if(!root) root = document;
  var $ = function(s){ return root.querySelector(s); };
  var $$ = function(s){ return root.querySelectorAll(s); };

  var THEME_PROMPTS = {
    "The Years Before":{ t:"The Years Before — a few things you might cover", items:[
      "What was an ordinary day like before? The mornings, the choices you made around clothes.",
      "What did you try that didn't work — brands, fabrics, remedies, workarounds?",
      "How did you come across Cottonique, and what did you expect?",
      "What's different now? Be specific — the small ordinary things often say the most."]},
    "The Thing I Got Back":{ t:"The Thing I Got Back — a few things you might cover", items:[
      "What's the one moment or activity that returned to you?",
      "What was it like to live without it?",
      "Tell us about the first time it came back. Where were you, what did you notice?",
      "What did that one thing change about the rest of your life?"]},
    "For Someone I Love":{ t:"For Someone I Love — a few things you might cover", items:[
      "Who were you searching for, and what were they going through?",
      "What was the hardest part of trying to help them?",
      "How did you find Cottonique, and what made you try it?",
      "What changed for them — and for you, watching it?"]}
  };

  var SCAFFOLD = {
    "The Years Before":
      "The years before\n(What did an ordinary day feel like back then? You might cover mornings and getting dressed, the fabrics or brands you'd learned to avoid, the small things you quietly stopped doing. Specific details say the most.)\n\n\n"+
      "What you tried\n(The creams, brands, fabrics, or workarounds that let you down — and how that wore on you over time.)\n\n\n"+
      "Finding Cottonique\n(How you came across it, and what you honestly expected. Skeptical is fine — most people were.)\n\n\n"+
      "What's different now\n(The change, in plain terms. Often it's one small ordinary thing — a full night's sleep, a shirt you forget you're wearing — that says it best.)\n\n",
    "The Thing I Got Back":
      "The one thing that came back\n(Name it plainly — the activity, the moment, the part of life that returned to you.)\n\n\n"+
      "Living without it\n(What was it like through the years you'd lost it? What did it quietly cost you?)\n\n\n"+
      "The first time it returned\n(Where were you, what were you doing, what did you notice in that moment?)\n\n\n"+
      "What it changed\n(How that one thing rippled out into the rest of your life.)\n\n",
    "For Someone I Love":
      "Who you were searching for\n(Who are they to you, and what were they going through?)\n\n\n"+
      "The hardest part\n(What was it like trying to help them — the worry, the dead ends, the things that didn't work?)\n\n\n"+
      "Finding Cottonique\n(How you came across it, and what finally made you try it for them.)\n\n\n"+
      "What changed\n(What's different for them now — and for you, watching it?)\n\n"
  };

  var lastScaffold = null;
  var CONDITIONS = [
    ["Eczema / dermatitis","Eczema / dermatitis"],
    ["Contact allergy · Type IV","Contact allergy · Type IV"],
    ["Latex · Type I (IgE)","Latex · Type I (IgE)"],
    ["Chemical sensitivity","Chemical sensitivity"],
    ["Psoriasis","Psoriasis"],
    ["Chronic hives","Chronic hives"],
    ["Post-surgical sensitivity","Post-surgical sensitivity"],
    ["Something else","Something else"]
  ];

  var state = { path:null, theme:null, conds:[], appear:null, comp:null };
  function val(id,v){ var el=$(id); if(el) el.value=v; }
  function get(id){ var el=$(id); return el?el.value.trim():""; }
  function condsList(){
    var other=get('#cq-other-cond');
    return state.conds.map(function(c){ return c==='Something else' ? other : c; }).filter(Boolean);
  }
  function syncConds(){ val('#cq-conds', condsList().join(', ')); }

  // paths
  $$('#cq-paths .cq-path').forEach(function(p){
    p.addEventListener('click',function(){
      $$('#cq-paths .cq-path').forEach(function(x){x.classList.remove('cq-sel');});
      p.classList.add('cq-sel'); state.path=p.dataset.path; val('#cq-path',state.path);
      var write = state.path==='write';
      $('#cq-write-block').style.display = write?'block':'none';
      $('#cq-talk-block').style.display = write?'none':'block';
      $('#cq-story-h').textContent = write?'Tell it to them — not to us':'Set up your call';
      $('#cq-story-sub').textContent = write
        ? "Picture the person right where you were — the same itch, the same sleepless nights, the same pile of returns, whether that was last month or years ago. Tell them what you wish someone had told you."
        : "Just a couple of details so we can reach you. You'll tell the story on the call — no need to write anything now.";
      validate();
    });
  });

  // themes
  $$('#cq-themes .cq-theme').forEach(function(t){
    t.addEventListener('click',function(){
      $$('#cq-themes .cq-theme').forEach(function(x){x.classList.remove('cq-sel');});
      t.classList.add('cq-sel'); state.theme=t.dataset.theme; val('#cq-theme',state.theme);
      var d=THEME_PROMPTS[state.theme];
      $('#cq-prompt-title').textContent=d.t;
      $('#cq-prompt-list').innerHTML=d.items.map(function(i){return '<li>'+i+'</li>';}).join('');
      $('#cq-prompts').classList.add('cq-show');
      var sc=SCAFFOLD[state.theme], box=$('#cq-story');
      if(box && sc){
        if(box.value.trim()==='' || box.value===lastScaffold){ box.value=sc; lastScaffold=sc; }
      }
      updateCount();
      validate();
    });
  });

  // conditions
  var cu=$('#cq-conds-ui');
  if(cu){
    cu.innerHTML=CONDITIONS.map(function(c){return '<button type="button" class="cq-check" data-c="'+c[0]+'">'+c[1]+'</button>';}).join('');
    cu.querySelectorAll('.cq-check').forEach(function(b){
      b.addEventListener('click',function(){
        b.classList.toggle('cq-on');
        var k=b.dataset.c;
        var i=state.conds.indexOf(k);
        if(i>-1) state.conds.splice(i,1); else state.conds.push(k);
        var hasOther = state.conds.indexOf('Something else')>-1;
        var wrap=$('#cq-other-wrap'), inp=$('#cq-other-cond');
        if(wrap) wrap.style.display = hasOther ? 'block' : 'none';
        if(!hasOther && inp) inp.value='';
        if(hasOther && inp) inp.focus();
        syncConds();
        updatePreview();
      });
    });
  }
  var oc=$('#cq-other-cond');
  if(oc){ oc.addEventListener('input',function(){ syncConds(); updatePreview(); }); }

  // appearance
  $$('#cq-appearance .cq-radio').forEach(function(r){
    r.addEventListener('click',function(){
      $$('#cq-appearance .cq-radio').forEach(function(x){x.classList.remove('cq-on');});
      r.classList.add('cq-on'); state.appear=r.dataset.appear; val('#cq-appear',state.appear);
      $('#cq-name-field').style.display = (state.appear==='Anonymous')?'none':'block';
      updatePreview(); validate();
    });
  });

  // comp
  $$('#cq-comp-ui .cq-opt').forEach(function(o){
    o.addEventListener('click',function(){
      $$('#cq-comp-ui .cq-opt').forEach(function(x){x.classList.remove('cq-on');});
      o.classList.add('cq-on'); state.comp=o.dataset.comp; val('#cq-comp',state.comp);
      validate();
    });
  });

  // live preview
  function setPV(id,v){ var el=$(id); if(!el) return; if(v){el.textContent=v; el.classList.remove('cq-empty');} else {el.textContent='—'; el.classList.add('cq-empty');} }
  function updatePreview(){
    var q=get('#cq-changed'); var pvq=$('#cq-pv-quote');
    if(!pvq) return;
    if(q){ pvq.textContent='“'+q+'”'; pvq.classList.remove('cq-empty'); }
    else { pvq.textContent='Your one-line story appears here'; pvq.classList.add('cq-empty'); }
    setPV('#cq-pv-conds', condsList().join(', '));
    setPV('#cq-pv-years', get('#cq-years'));
    setPV('#cq-pv-since', get('#cq-since'));
    setPV('#cq-pv-changed', q);
    var name='';
    if(state.appear==='Anonymous') name='Anonymous';
    else if(state.appear) name=get('#cq-name')||'(your name)';
    setPV('#cq-pv-name', name);
  }
  ['#cq-changed','#cq-years','#cq-since','#cq-name'].forEach(function(id){
    var el=$(id); if(el) el.addEventListener('input',updatePreview);
  });

  // word count
  var story=$('#cq-story');
  var clearBtn=$('#cq-clear');
  function updateCount(){
    if(!story) return;
    var raw=story.value;
    if(clearBtn) clearBtn.style.display = (raw.trim()==='') ? 'none' : 'inline';
    var el=$('#cq-wordcount'); if(!el) return;
    if(raw.trim()===''){ el.textContent='A few honest lines is plenty.'; return; }
    if(raw===lastScaffold){ el.textContent='Outline ready — write your part in. A few honest lines is plenty.'; return; }
    var w=raw.trim().split(/\s+/).filter(Boolean).length;
    el.textContent=w+(w===1?' word':' words')+' · a few honest lines is plenty.';
  }
  if(story){ story.addEventListener('input',function(){ updateCount(); validate(); }); }
  if(clearBtn){ clearBtn.addEventListener('click',function(){ story.value=''; lastScaffold=null; story.focus(); updateCount(); validate(); }); }

  // validation — every block tells the contributor what's missing
  var form = root.querySelector('#cq-intake-form');
  // noValidate is switched on from JS, not markup: if this script ever fails to
  // load, the browser's own `required` enforcement still gates consent.
  if(form) form.noValidate = true;

  var attempted = false;
  var MSG_IDS = ['#cq-msg-path','#cq-msg-appear','#cq-msg-name','#cq-msg-theme','#cq-msg-story',
                 '#cq-msg-phone','#cq-msg-email','#cq-msg-comp','#cq-msg-consent','#cq-msg-form'];
  var FIELD_ANCHORS = ['#cq-name','#cq-email','#cq-phone','#cq-story'];

  function msg(id,text){
    var el=$(id); if(!el) return;
    el.textContent = text || '';
    el.classList.toggle('cq-show', !!text);
  }
  function flag(el,on){
    if(!el) return;
    el.classList.toggle('cq-invalid', !!on);
    if(on) el.setAttribute('aria-invalid','true'); else el.removeAttribute('aria-invalid');
  }
  function consentBoxes(){ return [].slice.call($$('.cq-consent .cq-cb[required]')); }

  function checkAll(){
    var out=[];
    function add(m,anchor,text){ out.push({msg:m, anchor:anchor, text:text}); }

    if(!state.path) add('#cq-msg-path','#cq-paths',"Pick how you'd like to do this — write it yourself, or have us interview you.");

    if(!state.appear) add('#cq-msg-appear','#cq-appearance',"Choose how you'd like to appear on the record.");
    else if(state.appear!=='Anonymous' && !get('#cq-name')) add('#cq-msg-name','#cq-name',"Add the name you'd like shown, or choose Anonymous above.");

    if(!state.theme) add('#cq-msg-theme','#cq-themes',"Pick the shape your story takes — you're not locked into it.");

    if(state.path==='talk'){
      if(!get('#cq-phone')) add('#cq-msg-phone','#cq-phone','We need a number so we can set up your call.');
    } else if(state.path==='write'){
      var v = story ? story.value : '';
      if(v.trim()==='') add('#cq-msg-story','#cq-story','Your story is still empty — a few honest lines is plenty.');
      else if(v===lastScaffold) add('#cq-msg-story','#cq-story',"That's still the outline we started you off with — write your part in over it.");
      else if(v.trim().length<40) add('#cq-msg-story','#cq-story','A little more, please — a few honest lines is plenty.');
    }

    var em=$('#cq-email');
    if(em){
      if(!em.value.trim()) add('#cq-msg-email','#cq-email',"We need your email to confirm you're a Cottonique customer. It's never published.");
      else if(!em.checkValidity()) add('#cq-msg-email','#cq-email',"That email doesn't look right — please check it.");
    }

    if(!state.comp) add('#cq-msg-comp','#cq-comp-ui',"Choose the thank-you you'd like when your record is published.");

    var miss = consentBoxes().filter(function(b){ return !b.checked; });
    if(miss.length) add('#cq-msg-consent', miss[0], miss.length===1
      ? "One consent box below is still unticked — we can't publish your story without it."
      : miss.length + " consent boxes below are still unticked — we can't publish your story without them.");

    return out;
  }

  function render(list){
    MSG_IDS.forEach(function(id){ msg(id,''); });
    FIELD_ANCHORS.forEach(function(sel){ flag($(sel), false); });
    consentBoxes().forEach(function(b){ flag(b,false); flag(b.closest('.cq-cline'), false); });

    list.forEach(function(p){ msg(p.msg, p.text); });
    FIELD_ANCHORS.forEach(function(sel){
      if(list.some(function(p){ return p.anchor===sel; })) flag($(sel), true);
    });
    if(list.some(function(p){ return p.msg==='#cq-msg-consent'; })){
      consentBoxes().forEach(function(b){
        if(!b.checked){ flag(b,true); flag(b.closest('.cq-cline'), true); }
      });
    }
    msg('#cq-msg-form', list.length===0 ? '' : (list.length===1
      ? 'One thing still needs your attention above.'
      : list.length + ' things still need your attention above.'));
  }

  // Errors appear only after a submit attempt, then clear live as they're fixed.
  function validate(){ if(attempted) render(checkAll()); }

  if(form){
    form.addEventListener('submit', function(e){
      var list = checkAll();
      attempted = true;
      render(list);
      if(!list.length) return;
      e.preventDefault();
      var a = list[0].anchor;
      var el = (typeof a === 'string') ? $(a) : a;
      if(!el) return;
      el.scrollIntoView({behavior:'smooth', block:'center'});
      if(el.tagName==='INPUT' || el.tagName==='TEXTAREA'){
        try { el.focus({preventScroll:true}); } catch(err){ el.focus(); }
      }
    });
  }
  consentBoxes().forEach(function(b){ b.addEventListener('change', validate); });
  ['#cq-name','#cq-email','#cq-phone'].forEach(function(sel){
    var el=$(sel); if(el) el.addEventListener('input', validate);
  });

  updatePreview();
})();

  } catch(e) { console.error(e); }
})();
})();
